
        import 'Child.e281eb3.css-module'
        export default {"child":"child_Child_e281eb3"}
    